<template>
  <header :class="{ 'is-fixed': fixed}" class="rc-header" @click="clickEvent">
    <div class="rc-header__button is-left">
      <slot name="left"/>
    </div>
    <h1 class="rc-header__title">
      <span>{{ title }}</span>
    </h1>
    <div class="rc-header__button is-right">
      <slot name="right"/>
    </div>
  </header>
</template>
<script>
  export default {
    name: 'RcHeader',
    props: {
      title: {
        type: String,
        default: '线索提交'
      },
      fixed: Boolean,
      collapse: Boolean,
      dropdown: Boolean
    },
    data () {
      return {
        el: null,
        clickTimer: null,
        clickCount: 0
      }
    },
    methods: {
      clickEvent (e) {
        e.preventDefault()
        this.clickCount++
        if (this.clickCount === 1) { // 首次点击
          this.clickTimer = setTimeout(() => {
            this.clickCount = 0
          }, 300)
        } else { // 双击
          clearTimeout(this.clickTimer)
          this.clickCount = 0
          this.$emit('dbClick', e)
          this.scrollToTop()
        }
      },
      scrollToTop () {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        window.pageYOffset = 0
      }
    }
  }
</script>
<style lang="scss">
@include b(header) {
  display: flex;
  align-items: center;
  font-size: 16px;
  height: $header-height;
  color: #333333;
  // height: 12px;
  background-color: #ffffff;
  box-shadow: 0 1px 0 rgba($color: #000000, $alpha: 0.07);
  padding: 0 18px;

  @include e(button) {
    height: 50%;
    flex: 0.5;
    display: flex;
    align-items: center;

    .rc-button {
      background-color: transparent;
      border: 0;
      box-shadow: none;
      color: inherit;
      display: inline-block;
      padding: 0;
      font-size: inherit;
      width: 60px;
      height: inherit;
      text-align: left;

      &:active {
        background-color: transparent;

        &::after {
          border-color: transparent;
        }
      }

      &::after {
        content: none;
      }
    }

    @include when(left) {
      justify-content: flex-start;
    }

    @include when(right) {
      justify-content: flex-end;
    }
  }

  @include e(title) {
    flex: 1;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    span {
      font-size: 18px;
      color: #333333;
      text-align: center;
      display: inline-block;
      white-space: nowrap;
      text-overflow: nowrap;
      overflow: hidden;
    }
  }

  @include when(fixed) {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: $header-z-index;
  }
}

.rc-header[saas-header] {
  .rc-header__button {
    flex: none;
  }

  .rc-header__title {
    text-align: left;
    margin: 0 0 0 8px;
    justify-content: flex-start;
    font-weight: 600;
  }
}
</style>
